import cookie from "react-cookies";
import { RIMS_COOKIE_CONSTANTS } from "../constants";

export const useGlobalData = () => {
  const token = cookie.load(RIMS_COOKIE_CONSTANTS.LOGIN_TOKEN);
  const tenant = cookie.load(RIMS_COOKIE_CONSTANTS.USER_TENANT_ID);
  const domain = cookie.load(RIMS_COOKIE_CONSTANTS.DOMAIN);
  const userId = cookie.load(RIMS_COOKIE_CONSTANTS.USER_ID);
  return { token, tenant, domain, userId };
};

